export default __webpack_public_path__ + "static/IN-8015_2-8mm_lense_night_softwareWDR-f33a4ad88c2de4832793061548b942dc.webp";